import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";

const productionConfig = {
  apiKey: "AIzaSyCQonHGTeEdhNQV1XJufEyu-B6rP1msc6Y",
  authDomain: "newarc.firebaseapp.com",
  projectId: "newarc",
  storageBucket: "newarc.appspot.com",
  messagingSenderId: "593015570351",
  appId: "1:593015570351:web:bceaad57aee0ca74d8f95a"
};

// firebase init
const stagingConfig = {
//   apiKey: process.env.VUE_APP_API_KEY,
//   authDomain: process.env.VUE_APP_KEY_AUTH_DOMAIN,
//   databaseURL: process.env.VUE_APP_KEY_DATABASE_URL,
//   projectId: process.env.VUE_APP_PROJECT_ID,
//   storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
//   appId: process.env.VUE_APP_ID
    apiKey: "AIzaSyBq5h5fMtUIE5i0LKSY8B5y8s6SdG_g1dQ",
    authDomain: "newarc-staging.firebaseapp.com",
    projectId: "newarc-staging",
    storageBucket: "newarc-staging.appspot.com",
    messagingSenderId: "10485153929",
    appId: "1:10485153929:web:045ee5077dbb8a66ff0658"
}

// Quale progetto Firebase legge e scrive questo build. Era cablato a `true`:
// il sito servito da newarc-staging.web.app parlava con il Firestore di
// PRODUZIONE — gli annunci creati in staging non comparivano, e i "mi piace"
// e i lead finivano nel database vero (#639). Ora lo decide il mode di build
// (`.env.staging` / `.env.production`); senza la variabile — `npm run serve` in
// locale — resta produzione, com'era prima.
const isProduction = process.env.VUE_APP_FIREBASE_PROJECT !== 'staging';
const firebaseApp = firebase.initializeApp(
  isProduction ? productionConfig : stagingConfig
);

// #3141: the OAuth web client of each project's Google sign-in provider
// (Firebase Auth › Sign-in method › Google); "Accedi con Google" asks Google
// Identity Services for a token issued to it.
const googleClientIds = {
  production: "593015570351-s0838t55757nka8o5i5nc9vqb85l68uu.apps.googleusercontent.com",
  // Google provider enabled on newarc-staging 15/10/2026 (#3141).
  staging: "10485153929-p9mlhe5k5r4sbt32c5qg61ti2hi10tlm.apps.googleusercontent.com",
};
const googleClientId = isProduction ? googleClientIds.production : googleClientIds.staging;

// const firebaseApp = firebase.initializeApp(productionConfig)

// firebase.functions().useEmulator("http://localhost:5000");

// firebase db
const db = firebase.firestore()

// firebase auth
const auth = firebase.auth()

// firebase collections
const notesCollection = db.collection('notes')

const functions = getFunctions(firebaseApp);
// Callable di newarc-cloud-functions deployate in europe-west1, vicino a Firestore
// (eur3) e al bucket (EU): senza la regione esplicita l'SDK le cercherebbe in
// us-central1. Oggi le usano gli upload della richiesta preventivo (#667).
const functionsEurope = getFunctions(firebaseApp, 'europe-west1');
const storage = getStorage(firebaseApp);

// Local-only: route Firestore + Auth through the Firebase Emulator Suite when
// explicitly enabled (VUE_APP_USE_EMULATOR=true, e.g. `npm run dev:emulator`).
// vue-cli/webpack inlines this VUE_APP_* var at build time; the flag is unset in
// production/staging builds, so this never runs there.
if (process.env.VUE_APP_USE_EMULATOR === 'true') {
  // Porte override-abili via env (default = firebase.json): utile quando la
  // 8080 è già occupata (es. dev server docker) e l'emulatore gira altrove.
  db.useEmulator('localhost', Number(process.env.VUE_APP_EMULATOR_FIRESTORE_PORT || 8080));
  auth.useEmulator(`http://localhost:${process.env.VUE_APP_EMULATOR_AUTH_PORT || 9099}`, { disableWarnings: true });
  // Keep callable functions local so emulator mode never reaches PROD functions.
  // (If the Functions emulator isn't running, calls fail locally instead.)
  connectFunctionsEmulator(functions, 'localhost', Number(process.env.VUE_APP_EMULATOR_FUNCTIONS_PORT || 5001));
  connectFunctionsEmulator(functionsEurope, 'localhost', Number(process.env.VUE_APP_EMULATOR_FUNCTIONS_PORT || 5001));
}

export {
  isProduction,
  firebaseApp,
  stagingConfig,
  productionConfig,
  auth,
  db,
  firebase,
  notesCollection,
  functions,
  functionsEurope,
  storage,
  googleClientId
}